import React, { useState, useEffect, useRef, useCallback } from 'react';
import { createNotification } from '../helpers/Notification';
import Loader from '../common/Loader';
import { checkValidPasswpord, getLoginToken, isImage, checkImageSize, getApiUrl } from '../helpers/Util';
import axios from 'axios';
import { DropDown } from '../common';
import { FaPen } from 'react-icons/fa';
import ConfirmBox from "../common/ConfirmBox";
import SimpleReactValidator from 'simple-react-validator';
import masterDataService from '../services/MasterDataService';
import AccessDenied from '../common/AccessDenied';
import { rules, Permission } from "../../abac.config";
import { useSelector } from 'react-redux';
import { useNavigate, useParams, Link } from 'react-router-dom';

const AddUser = () => {
  const loginUserData = useSelector(state => state.loginUserData);
  const navigate = useNavigate();
  const params = useParams();
  const validator = useRef(new SimpleReactValidator());
  const [state, setState] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    organization: "",
    country: "",
    status: "Active",
    role: 1,
    roleList: [],
    loader: false,
    selectedFile: null,
    imagePreviewUrl: null,
    onchangeImg: false,
    userId: null,
    dbImage: null,
    headingText: 'Add',
    button: 'Save',
    isRolePmFlag: false,
    ColorList: [],
    selectedColor: "xyz",
    isColorNotSelected: false,
    isShowConfirmBox: false,
    isShowRoleChangeConfirmBox: false,
    requiresConfirmation: false,
    confirmRoleChangeFlag: false,
    confirmRoleChange: "",
    userData: [],
    data: {},
    originalRoleTitle: "",
    initialStatus: "Active",
    isShowInactiveConfirmBox: false,
    confirmInactiveFlag: false,
    isShowActiveConfirmBox: false,
    confirmActiveFlag: false,
  });
  const [, forceUpdate] = useState();

  useEffect(() => {
    if (window.history.state && window.history.state.state !== undefined) {
      localStorage.setItem('userListPaginationConstants', JSON.stringify({
        previousPage: window.history.state.state.data.pageChange,
        previousLimit: window.history.state.state.data.limit,
        previousSkip: window.history.state.state.data.skip,
        previousSearch: window.history.state.state.data.search
      }));
    }
    getRoleList();
    getUserList();
    if (params.userId !== null && params.userId !== undefined) {
      setState(prev => ({ ...prev, userId: params.userId, headingText: 'Edit', button: 'Update' }));
      getUserById(params.userId);
      getAvailableColorCodes(params.userId);
    } else {
      getAvailableColorCodes("null");
    }
    // eslint-disable-next-line
  }, [params.userId]);

  const getUserList = useCallback(() => {
    const token = getLoginToken();
    const headers = {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": `Bearer ${token}`
    };
    const URL = getApiUrl();
    const url = `${URL}/users`;
    axios.get(url, { headers })
      .then((response) => {
        if (response.status) {
          let responseData = response.data.data.data;
          handleUserList(responseData);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          createNotification("error", "Your login session has been expired!");
          localStorage.clear();
          navigate('/login');
        } else {
          createNotification("error", error?.response?.data?.message || "An error occurred");
        }
      });
  }, [navigate]);

  const handleUserList = (responseData) => {
    let listArr = [];
    responseData && responseData.map((item) => {
      let itemData = { ...item };
      itemData.role = itemData.role && itemData.role.title;
      itemData.status = itemData.status.charAt(0).toUpperCase() + itemData.status.slice(1);
      itemData.profilePic = itemData.upload_fkey && itemData.upload_fkey.filePath;
      listArr.push(itemData);
      return null;
    });
    setState(prev => ({ ...prev, userData: listArr }));
  };

  const getAvailableColorCodes = (userId) => {
    masterDataService.getAvailableColorCodes(userId).then((response) => {
      if (response.status === 200) {
        let responseData = response.data.data;
        let listArr = [];
        responseData && responseData.map((item) => {
          listArr.push({ lable: item.name, value: item.colorCode });
          return null;
        });
        setState(prev => ({ ...prev, ColorList: listArr }));
      }
    }).catch(() => {});
  };

  const getRoleList = useCallback(() => {
    const token = getLoginToken();
    const headers = {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": `Bearer ${token}`
    };
    const URL = getApiUrl();
    const url = `${URL}/roles`;
    axios.get(url, { headers })
      .then((response) => {
        console.log("response", response);
        if (response.status === 200) {
          let responseData = response.data.data;
          let listArr = [];
          responseData && responseData.map((item) => {
            listArr.push({ lable: item.title, value: item.id });
            return null;
          });
          setState(prev => ({ ...prev, roleList: listArr }));
        }
      })
      .catch(() => { });
  }, []);

  const getUserById = (userId) => {
    const token = getLoginToken();
    if (userId !== "") {
      const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      };
      const URL = getApiUrl();
      const url = `${URL}/users/${userId}`;
      axios.get(url, { headers })
        .then((response) => {
          if (response.status) {
            let resData = response.data.data;
            setState(prev => ({
              ...prev,
              isRolePmFlag: resData.role.title === "Project Manager",
              originalRoleTitle: resData.role.title,
              name: resData.name,
              email: resData.email,
              phone: resData.phone,
              country: resData.country,
              organization: resData.organization,
              dbImage: resData.upload_fkey ? resData.upload_fkey.filePath : "",
              role: resData.role.id,
              status: (resData.status === "ACTIVE" ? "Active" : "Inactive"),
              initialStatus: (resData.status === "ACTIVE" ? "Active" : "Inactive"),
              selectedColor: resData.colorCode
            }));
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            createNotification("error", "Your login session has been expired!");
            localStorage.clear();
            navigate('/login');
          } else {
            createNotification("error", error?.response?.data?.message || "An error occurred");
          }
        });
    }
  };

  const fileChangedHandler = (event) => {
    if (isImage(event.target.files[0].name)) {
      if (checkImageSize(event.target.files[0].size)) {
        setState(prev => ({
          ...prev,
          selectedFile: event.target.files[0]
        }));
        let reader = new FileReader();
        reader.onloadend = () => {
          setState(prev => ({
            ...prev,
            imagePreviewUrl: reader.result,
            onchangeImg: true
          }));
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        createNotification("info", "File size maximum up 5MB");
      }
    } else {
      createNotification("info", "Please select valid image format!");
    }
  };

  const onCancelImg = () => {
    setState(prev => ({
      ...prev,
      imagePreviewUrl: null,
      onchangeImg: false
    }));
  };

  const onSaveImg = () => {
    const token = getLoginToken();
    const headers = { "Authorization": `Bearer ${token}` };
    setState(prev => ({ ...prev, loader: true }));
    const URL = getApiUrl();
    const url = `${URL}/users/profileUpload`;
    var fd = new FormData();
    fd.append('profileImage', state.selectedFile);
    fd.append('userId', state.userId);
    axios.post(url, fd, { headers })
      .then((response) => {
        setState(prev => ({
          ...prev,
          onchangeImg: false,
          loader: false,
          imagePreviewUrl: null,
          dbImage: response.data.data.filePath
        }));
      })
      .catch((error) => {
        setState(prev => ({ ...prev, loader: false }));
        if (error.response && error.response.status === 401) {
          createNotification("error", "Your login session has been expired!");
          localStorage.clear();
          navigate('/login');
        } else {
          createNotification("error", error?.response?.data?.message || "An error occurred");
        }
      });
  };

  const handleOnChange = useCallback((event) => {
    const { name, value } = event.target;
    setState(prev => {
      let newState = { ...prev };
      if (name === "role") {
        if (value === "3") {
          newState.isRolePmFlag = true;
          newState.selectedColor = "";
        } else {
          newState.isRolePmFlag = false;
          newState.selectedColor = "xyz";
          newState.isColorNotSelected = false;
        }
      }
      newState[name] = value;
      return newState;
    });
  }, []);

  const handleOnChangeColor = useCallback((event) => {
    if (event.target.name === "pmcolor") {
      setState(prev => ({
        ...prev,
        selectedColor: event.target.value,
        isColorNotSelected: false
      }));
    }
  }, []);

  const checkInputData = () => {
    const { name, email, phone } = state;
    let isValidate = true;
    if (name === "") {
      createNotification("error", "User name is required!");
      isValidate = false;
    } else if (email === "") {
      createNotification("error", "Email is required!");
      isValidate = false;
    } else if (phone === "") {
      createNotification("error", "Phone Number is required!");
      isValidate = false;
    }
    return isValidate;
  };

  const handleResetState = () => {
    setState(prev => ({
      ...prev,
      name: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
      organization: "",
      country: "",
      status: "Active",
      imagePreviewUrl: null,
      onchangeImg: false,
      userId: null,
      dbImage: null,
      headingText: 'Add',
      button: 'Save',
      role: 1,
      initialStatus: "Active",
      isShowInactiveConfirmBox: false,
      confirmInactiveFlag: false,
      isShowActiveConfirmBox: false,
      confirmActiveFlag: false
    }));
  };

  const handleSaveUser = useCallback((isActionConfirmed = false) => {
    const { name, email, phone, password, organization, country, status, role, userId, selectedColor, isRolePmFlag, confirmRoleChange, confirmRoleChangeFlag, requiresConfirmation, initialStatus, confirmInactiveFlag, confirmActiveFlag } = state;
    if (validator.current.allValid() && isRolePmFlag === false) {
      if (checkInputData()) {
        if (params.userId !== null && params.userId !== undefined && status === "Inactive" && initialStatus === "Active" && !confirmInactiveFlag && isActionConfirmed !== true) {
          setState(prev => ({ ...prev, isShowInactiveConfirmBox: true }));
          return;
        }
        if (params.userId !== null && params.userId !== undefined && status === "Active" && initialStatus === "Inactive" && !confirmActiveFlag && isActionConfirmed !== true) {
          setState(prev => ({ ...prev, isShowActiveConfirmBox: true }));
          return;
        }
        const token = getLoginToken();
        const headers = {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        };
        setState(prev => ({ ...prev, loader: true }));
        const URL = getApiUrl();
        let url = "";
        const data = { name, email, phone, country, organization: Number(organization), role: Number(role), status, colorCode: selectedColor };
        if (params.userId !== null && params.userId !== undefined) {
          url = `${URL}/users/${userId}`;
          axios.patch(url, data, { headers })
            .then((response) => {
              let reqConfirmation = response?.data?.data?.requiresConfirmation !== undefined ? response?.data?.data?.requiresConfirmation : response?.data?.requiresConfirmation;
              if (reqConfirmation === true && response.status === 200) {
                setState(prev => ({ ...prev, isShowRoleChangeConfirmBox: true, loader: false, data: data, requiresConfirmation: true }));
                return;
              } else if (response.status === 200) {
                createNotification("success", "User Updated successfully!");
                handleResetState();
                setState(prev => ({ ...prev, loader: false }));
                navigate('/user');
              }
            })
            .catch((error) => {
              let reqConfirmation = error.response?.data?.data?.requiresConfirmation !== undefined ? error.response?.data?.data?.requiresConfirmation : error.response?.data?.requiresConfirmation;
              if (reqConfirmation === true) {
                setState(prev => ({ ...prev, isShowRoleChangeConfirmBox: true, loader: false, data: data, requiresConfirmation: true }));
                return;
              }
              if (error.response?.status === 401) {
                createNotification("error", "Your login session has expired!");
                localStorage.clear();
                navigate('/login');
              } else {
                createNotification("error", error?.response?.data?.message || "An error occurred");
              }
              setState(prev => ({ ...prev, loader: false }));
            });
        } else {
          url = `${URL}/users`;
          axios.post(url, data, { headers })
            .then((response) => {
              if (response.status === 201) {
                createNotification("success", "User added successfully!");
                handleResetState();
                setState(prev => ({ ...prev, loader: false }));
                navigate('/user');
              }
            })
            .catch((error) => {
              if (error.response.status === 401) {
                createNotification("error", "Your login session has been expired!");
                localStorage.clear();
                navigate('/login');
                setState(prev => ({ ...prev, loader: false }));
              } else {
                const filteredObjects = state.userData.filter(obj => obj.email === state.email);
                if (filteredObjects.length === 0) {
                  setTimeout(() => {
                    setState(prev => ({ ...prev, isShowConfirmBox: true, loader: false }));
                  }, 1500);
                } else {
                  createNotification("error", error.response.data.message);
                  setState(prev => ({ ...prev, loader: false }));
                }
              }
            });
        }
      }
    } else if (validator.current.allValid() && isRolePmFlag === true && selectedColor !== "0" && selectedColor !== "") {
      if (params.userId !== null && params.userId !== undefined && status === "Inactive" && initialStatus === "Active" && !confirmInactiveFlag && isActionConfirmed !== true) {
        setState(prev => ({ ...prev, isShowInactiveConfirmBox: true }));
        return;
      }
      if (params.userId !== null && params.userId !== undefined && status === "Active" && initialStatus === "Inactive" && !confirmActiveFlag && isActionConfirmed !== true) {
        setState(prev => ({ ...prev, isShowActiveConfirmBox: true }));
        return;
      }
      const token = getLoginToken();
      const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      };
      setState(prev => ({ ...prev, loader: true }));
      const URL = getApiUrl();
      let url = "";
      const data = { name, email, phone, country, organization: Number(organization), role: Number(role), status, colorCode: selectedColor };
      if (params.userId !== null && params.userId !== undefined) {
        url = `${URL}/users/${userId}`;
        axios.patch(url, data, { headers })
          .then((response) => {
            if (response.status === 200) {
              createNotification("success", "User Updated successfully!");
              handleResetState();
              setState(prev => ({ ...prev, loader: false }));
              navigate('/user');
            }
          })
          .catch((error) => {
            if (error.response.status === 401) {
              createNotification("error", "Your login session has been expired!");
              localStorage.clear();
              navigate('/login');
              setState(prev => ({ ...prev, loader: false }));
            } else {
              createNotification("error", error.response.data.message);
              setState(prev => ({ ...prev, loader: false }));
            }
          });
      } else {
        url = `${URL}/users`;
        axios.post(url, data, { headers })
          .then((response) => {
            if (response.status === 201) {
              createNotification("success", "User added successfully!");
              handleResetState();
              setState(prev => ({ ...prev, loader: false }));
              navigate('/user');
            }
          })
          .catch((error) => {
            if (error.response.status === 401) {
              createNotification("error", "Your login session has been expired!");
              localStorage.clear();
              navigate('/login');
              setState(prev => ({ ...prev, loader: false }));
            } else {
              const filteredObjects = state.userData.filter(obj => obj.email === state.email);
              if (filteredObjects.length === 0) {
                setTimeout(() => {
                  setState(prev => ({ ...prev, isShowConfirmBox: true, loader: false }));
                }, 1500);
              } else {
                createNotification("error", error.response.data.message);
                setState(prev => ({ ...prev, loader: false }));
              }
            }
          });
      }
    } else {
      if (isRolePmFlag === true && (selectedColor === "0" || selectedColor === "")) {
        setState(prev => ({ ...prev, isColorNotSelected: true }));
        validator.current.showMessages();
        forceUpdate(1);
      } else {
        validator.current.showMessages();
        forceUpdate(1);
      }
    }
  }, [state, params.userId, navigate]);

  const handleChangePmRole = (isConfirmed = false) => {
    const { data, confirmRoleChangeFlag, requiresConfirmation, userId } = state;
    const token = getLoginToken();
    const headers = {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": `Bearer ${token}`
    };
    setState(prev => ({ ...prev, loader: true }));
    const URL = getApiUrl();
    if (requiresConfirmation === true && (confirmRoleChangeFlag === true || isConfirmed === true)) {
      let urlNew = `${URL}/users/${userId}?confirmRoleChange=true`;
      axios.patch(urlNew, data, { headers })
        .then((response) => {
          createNotification("success", "User Updated successfully!");
          handleResetState();
          setState(prev => ({ ...prev, loader: false, isShowRoleChangeConfirmBox: false }));
          navigate('/user');
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            createNotification("error", "Your login session has been expired!");
            localStorage.clear();
            navigate('/login');
          } else {
            createNotification("error", error?.response?.data?.message || "An error occurred");
          }
          setState(prev => ({ ...prev, loader: false, isShowRoleChangeConfirmBox: false }));
        });
    } else {
      setState(prev => ({ ...prev, loader: false }));
    }
  };

  const handleConfirmModal = (isYes) => {
    if (isYes) {
      navigate(`/restore/${state.email}`);
    } else {
      setState(prev => ({ ...prev, isShowConfirmBox: false }));
    }
  };

  const handleConfirmRoleChangeModal = (isYes) => {
    if (isYes) {
      setState(prev => ({ ...prev, confirmRoleChangeFlag: true, isShowRoleChangeConfirmBox: false }));
      handleChangePmRole(true);
    } else {
      setState(prev => ({ ...prev, isShowRoleChangeConfirmBox: false }));
    }
  };

  const handleConfirmInactiveModal = (isYes) => {
    if (isYes) {
      setState(prev => ({ ...prev, confirmInactiveFlag: true, isShowInactiveConfirmBox: false }));
      handleSaveUser(true);
    } else {
      setState(prev => ({ ...prev, isShowInactiveConfirmBox: false, confirmInactiveFlag: false }));
    }
  };

  const handleConfirmActiveModal = (isYes) => {
    if (isYes) {
      setState(prev => ({ ...prev, confirmActiveFlag: true, isShowActiveConfirmBox: false }));
      handleSaveUser(true);
    } else {
      setState(prev => ({ ...prev, isShowActiveConfirmBox: false, confirmActiveFlag: false }));
    }
  };

  // Render logic
  const imgUrl = state.imagePreviewUrl ? state.imagePreviewUrl : state.dbImage;
  let imagePreview = (<div className="imagePreview"></div>);
  if (imgUrl) {
    imagePreview = (<div className="imagePreview" style={{ backgroundImage: `url(${imgUrl})` }} ></div>);
  }
  let roleKey = loginUserData.roleKey;
  const isAccess = (roleKey !== "" && rules[roleKey][Permission.USER_WRITE]) ? true : false;

  console.log("state", state);
  return (
    <div>
      {state.loader ? (
        <Loader />
      ) : (
        <div>
          {!isAccess ? <AccessDenied /> :
            <div className="main-content addUser-form">
              <ConfirmBox
                openModal={state.isShowConfirmBox}
                confirmMsg="Are you sure  you want to restore this user?"
                handleConfirmModal={handleConfirmModal}
              />
              <ConfirmBox
                openModal={state.isShowRoleChangeConfirmBox}
                confirmMsg="This PM is currently assigned to a field crew. Do you want to change the role? This will remove the PM from the Field Crew Master Data."
                handleConfirmModal={handleConfirmRoleChangeModal}
              />
              <ConfirmBox
                openModal={state.isShowInactiveConfirmBox}
                confirmMsg="Are you sure you want to inactive this user? This will log them out and prevent them from logging in."
                handleConfirmModal={handleConfirmInactiveModal}
              />
              <ConfirmBox
                openModal={state.isShowActiveConfirmBox}
                confirmMsg="Are you sure you want to activate this user? They will now be able to login."
                handleConfirmModal={handleConfirmActiveModal}
              />
              <div className="page-content">
                <div className="container-fluid">
                  <div className="page-title-box d-flex align-items-center justify-content-between">
                    <ol className="breadcrumb m-0">
                      <Link to={`/#`}><li className="breadcrumb-item">Home</li></Link>
                      &nbsp; / &nbsp;
                      <Link to={`/user`}><li className="breadcrumb-item">User</li></Link>
                      &nbsp; / &nbsp;
                      {params.userId === undefined ?
                        <Link to={`/adduser`}><li className="breadcrumb-item">Add</li></Link>
                        : params.userId !== undefined ?
                          <Link to={`/update/${params.userId}`}><li className="breadcrumb-item">Update</li></Link>
                          : ''}
                    </ol>
                  </div>
                  <h4 className="mb-0">{state.headingText} User</h4>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card card-block">
                        <div className="card-body">
                          <div className="wizard clearfix">
                            <div className="content clearfix">
                              <form className="form-project ">
                                {state.userId !== null &&
                                  <div className="row">
                                    <div className="col-sm-12 col-md-3 imgUp uploadFile-image">
                                      <div className="mb-3 uploadImgWrap">
                                        {imagePreview}
                                        <label className="btn btn-primary">
                                          <FaPen />
                                          <input type="file" className="uploadFile img" value=""
                                            style={{ width: "0px", height: "0px", overflow: "hidden" }} onChange={fileChangedHandler} />
                                        </label>
                                      </div>
                                    </div>
                                    {state.onchangeImg &&
                                      <>
                                        <div className="row">
                                          <div className="col-sm-12 col-md-2">
                                            <button type="button" className="btn btn-primary waves-effect waves-light" onClick={onSaveImg} >
                                              <i className="uil uil-save"></i> Save
                                            </button>
                                          </div>
                                          <div className="col-sm-12 col-md-2">
                                            <button type="button" className="btn btn-primary waves-effect waves-light" onClick={onCancelImg} >
                                              <i className="uil uil-cancel"></i> Cancel
                                            </button>
                                          </div>
                                        </div>
                                        <div style={{ marginBottom: "10px" }}></div>
                                      </>
                                    }
                                  </div>
                                }
                                <div className="row">
                                  <div className="col-md-4 col-sm-12">
                                    <div className="mb-3">
                                      <label className="form-label" htmlFor="validationCustom01">Name    <span style={{ color: 'red' }}>*</span></label>
                                      <input type="text" className="form-control" id="validationCustom01" name="name" onChange={handleOnChange} placeholder="Name"
                                        required value={state.name} />
                                      {validator.current.message('name', state.name, 'required|max:70', { className: 'text-danger' })}
                                    </div>
                                  </div>
                                  <div className="col-md-4 col-sm-12">
                                    <div className="mb-3">
                                      <label className="form-label" htmlFor="validationCustom01">Email ID <span style={{ color: 'red' }}>*</span></label>
                                      <input type="text" className="form-control" id="validationCustom01"
                                        name="email" onChange={handleOnChange} placeholder="Email"
                                        required value={state.email} disabled={state.userId !== null} />
                                      {validator.current.message('email', state.email, 'required|email', { className: 'text-danger' })}
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-md-4 col-sm-12">
                                    <div className="mb-3">
                                      <label className="form-label" htmlFor="validationCustom02">Phone Number <span style={{ color: 'red' }}>*</span></label>
                                      <input type="text" className="form-control" id="validationCustom02"
                                        name="phone" onChange={handleOnChange} placeholder="Phone number"
                                        required value={state.phone} />
                                      {validator.current.message('phone', state.phone, 'required|numeric|min:10|max:10', { className: 'text-danger' })}
                                    </div>
                                  </div>
                                  <div className="col-md-4 col-sm-12">
                                    <div className="mb-3">
                                      <label className="form-label" htmlFor="validationCustom01">Status</label>
                                      <DropDown
                                        name="status"
                                        options={[{ lable: 'Active', value: 'Active' }, { lable: 'Inactive', value: 'Inactive' }]}
                                        onChange={handleOnChange}
                                        defaultSelected={state.status}
                                        lable=""
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-md-4 col-sm-12">
                                    <div className="mb-3">
                                      <label className="form-label" htmlFor="validationCustom02">User Role</label>
                                      <DropDown
                                        name="role"
                                        options={state.roleList}
                                        onChange={handleOnChange}
                                        defaultSelected={state.role}
                                        lable=""
                                      />
                                    </div>
                                  </div>
                                  {state.isRolePmFlag === true ?
                                    <div className="col-md-4 col-sm-12">
                                      <div className="mb-3">
                                        <label className="form-label" htmlFor="validationCustom02">Project Manager Color</label>
                                        <DropDown
                                          name="pmcolor"
                                          firstOption={{ lable: 'Select Color', value: 0 }}
                                          options={state.ColorList}
                                          onChange={handleOnChangeColor}
                                          defaultSelected={state.selectedColor}
                                          lable=""
                                        />
                                        {state.isColorNotSelected === true ? <p className='text-danger'>The color field is required . </p> : ""}
                                      </div>
                                    </div> : ""}
                                </div>
                              </form>
                            </div>
                            <div className="actions clearfix">
                              <button type="button" className="btn btn-primary waves-effect waves-light" onClick={handleSaveUser}>
                                <i className="uil uil-edit"></i> {state.button}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      )}
    </div>
  );
};

export default AddUser;